import { Route, Routes } from 'react-router-dom';
import LocationsList from './locations-list';
import LocationsItem from './locations-item';

const LocationsRouting = () => {
  return (
    <Routes>
      <Route path='' element={<LocationsList />} />
      <Route path=':uid' element={<LocationsItem />} />
    </Routes>
  );
};

export default LocationsRouting;
